/* src/app/shared/calendar/calendar.component.scss */
tr {
  display: inline-flex;
  align-content: center;
  align-items: center;
  justify-content: space-evenly;
}
td {
  display: inline-flex;
  color: #636363;
  font-size: medium;
  text-align: center;
  height: 9vw;
  width: 12vw;
  vertical-align: middle;
  flex-direction: row;
  align-items: center;
}
.tdText {
  width: 9vw;
}
table {
  max-width: min-content;
  border-radius: 2vw;
  box-shadow: 0 0 2px black;
}
th {
  width: 12vw;
  font-size: medium;
}
.activities {
  max-width: 3vw;
  max-height: 9vw;
}
.today {
  font-weight: bolder;
}
.run,
.virtualrun,
.yoga {
  background:
    radial-gradient(
      circle,
      rgb(255, 177, 0) 50%,
      rgba(255, 177, 0, 0) 50%);
  width: 3vw;
  height: 3vw;
  background-repeat: no-repeat;
  background-position: center;
}
.walk,
.snowshoe,
.golf,
.soccer {
  background:
    radial-gradient(
      circle,
      lime 50%,
      rgba(255, 177, 0, 0) 50%);
  width: 3vw;
  height: 3vw;
  background-repeat: no-repeat;
  background-position: center;
}
.ride,
.virtualride,
.velomobile,
.ebikeride,
.handcycle,
.wheelchair {
  background:
    radial-gradient(
      circle,
      #16b800 50%,
      rgba(255, 177, 0, 0) 50%);
  width: 3vw;
  height: 3vw;
  background-repeat: no-repeat;
  background-position: center;
}
.swim,
.kitesurf,
.sail,
.surfing,
.windsurf {
  background:
    radial-gradient(
      circle,
      #2a7efc 50%,
      rgba(255, 177, 0, 0) 50%);
  width: 3vw;
  height: 3vw;
  background-repeat: no-repeat;
  background-position: center;
}
.workout,
.weighttraining,
.hike,
.elliptical,
.crossfit {
  background:
    radial-gradient(
      circle,
      red 50%,
      rgba(255, 177, 0, 0) 50%);
  width: 3vw;
  height: 3vw;
  background-repeat: no-repeat;
  background-position: center;
}
.elliptical,
.rowing,
.stairstepper,
.standuppaddling {
  background:
    radial-gradient(
      circle,
      rgb(128, 35, 35) 50%,
      rgba(255, 177, 0, 0) 50%);
  width: 3vw;
  height: 3vw;
  background-repeat: no-repeat;
  background-position: center;
}
.canoeing,
.kayaking {
  background:
    radial-gradient(
      circle,
      rgb(0, 49, 139) 50%,
      rgba(255, 177, 0, 0) 50%);
  width: 3vw;
  height: 3vw;
  background-repeat: no-repeat;
  background-position: center;
}
.rockclimbing,
.hike {
  background:
    radial-gradient(
      circle,
      rgb(119, 67, 0) 50%,
      rgba(255, 177, 0, 0) 50%);
  width: 3vw;
  height: 3vw;
  background-repeat: no-repeat;
  background-position: center;
}
.alpineski,
.backcountryski,
.snowboard,
.nordicski,
.rollerski,
.iceskate,
.inlineskate,
.skateboard {
  background:
    radial-gradient(
      circle,
      rgb(58, 58, 58) 50%,
      rgba(255, 177, 0, 0) 50%);
  width: 3vw;
  height: 3vw;
  background-repeat: no-repeat;
  background-position: center;
}
.hidden {
  background: none !important;
}
.spinner {
  min-height: 20vw;
  min-width: 90vw;
  text-align: center;
  padding-top: 20vw;
  padding-bottom: 20vw;
  border: 1px solid gray;
  border-radius: 2vw;
}
/*# sourceMappingURL=calendar.component.css.map */
